module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAABI0lEQVRYhe3W3Q2CMBSG4bfGARzBDWQALljBCdQFGIYF1A0cwQvu1Q0cwQ0wJ6kJVip/PTUmfDelhaRPTg8BpvxbTAxvlacZsAGWwAM4mqI8NT2rDqrydAvsG24dTFHuooK+YF5Zu5Wa/RCDPca3qIA6YiQLdVAPjOSuCuqJkRzVQAMwO1OUZ3cxyFs2EHNoujEaFBIzGhQaMwqkgRkM0sIMAmlieoO0Mb1AMTCdQbEwnUAxMa2g2JivoF9gCPhxDYKRzN2FKk8TIJENqjylQ5WCYfBUSEB7OTK70cePuBbGB1rZsQ0VHOMDJbVrH0oFQ1MPAZkzFxS1nkILg/va24a+eJ5Vq0o9boUSZy7/vFfgZkf1uKC77ZWrKcoogClTggZ4AvkGlCpy9WhvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_btn_edit@2x.png
// module id = 722
// module chunks = 0